import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyBN5zqbAOLPHSfgVyn-iTudGlAtt_HWodk",
  authDomain: "flowio.firebaseapp.com",
  databaseURL: "https://flowio.firebaseio.com",
  projectId: "flowio",
  storageBucket: "flowio.appspot.com",
  messagingSenderId: "648006606400",
  appId: "1:648006606400:web:f92514f86b6a9046de49a5",
  measurementId: "G-N88BM2MM21",
};

initializeApp(firebaseConfig);
